<template>
  <div class="card card-shadow">
    <div class="card-header">
      <div class="row">
        <div class="col">
          <div>{{ userEntity.entity.name }}</div>
          <div :class="resourceTypeClass">
            {{ userEntity.resource_type == 'intern' ? $i18n.t('models.resource_type.intern') : $i18n.t('models.resource_type.extern') }}
          </div>
        </div>

        <div class="col" v-if="withActions">
          <div class="btn-toolbar flex-wrap justify-content-end">
            <div class="btn-group">
              <button type="button" class="btn btn-icon" @click="onEdit">
                <i class="fa fa-edit"></i>
              </button>
              <button class="btn btn-icon-dark" @click="onDelete">
                <i class="fa fa-trash-o"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md mb-3 mb-md-0">
          <div class="description">Service(s) de remplacement(s): </div>
          <services-grouped-by-hubs :services="userEntity.services" :hubs="hubs" />
        </div>

        <div class="col-md mb-3 mb-md-0" v-if="affiliatedService.length > 0">
          <div class="description">Service de rattachement: </div>
          <services-grouped-by-hubs :services="affiliatedService" :hubs="hubs" :shortened="false" />
        </div>

        <div class="col-md mb-3 mb-md-0">
          <div class="description">Métier(s): </div>
          <div><b>{{ occupationName }}</b></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ServicesGroupedByHubs from '@/components/hubs/ServicesGroupedByHubs'

  export default {
    name: 'CandidateEntityRow',
    props: {
      userEntity: Object,
      withActions: { type: Boolean, default: false }
    },
    components: {
      ServicesGroupedByHubs
    },
    computed: {
      entity() {
        return this.userEntity.entity
      },
      entityName() {
        return this.entity.name
      },
      servicesName() {
        return this.userEntity.services.map(service => service.name).join(' / ')
      },
      occupationName() {
        return this.userEntity.occupations.map(occupation => occupation.name).join(' / ')
      },
      resourceType() {
        return this.isInternal ? this.$i18n.t('yes') : this.$i18n.t('no');
      },
      affiliatedService() {
        if (this.isInternal && this.hasAffiliatedService) {
          return [this.userEntity.affiliated_service]
        }

        return []
      },
      hubs() {
        if(this.entity && this.entity.hubs) {
          return this.entity.hubs
        }

        return []
      },
      isInternal() {
        return this.userEntity.resource_type === 'intern';
      },
      hasAffiliatedService() {
        return this.userEntity.affiliated_service !== null;
      },
      resourceTypeClass() {
        return this.isInternal ? 'badge-intern' : 'badge-extern'
      },
    },
    methods: {
      onEdit() {
        this.$emit('edit', this.userEntity);
      },
      onDelete() {
        this.$dialog.confirm(this.$t('UserEntity.decline_confirm'))
          .then(() => this.$emit('delete', this.userEntity))
      },
    }
  }
</script>

<style scoped>
h4.section-title {
  width: 100%;
  text-align: left;
  border-bottom: 2px solid #f1f1f1;
  line-height: 0.1em;
  margin: 10px 0 20px;
  font-family: 'Montserrat';
    font-weight: 600;
    font-size: 14px;
  }

  .section-title span {
    background: #fff;
    padding: 0 10px;
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// src/components/entities/CandidateEntityRow.vue